import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';
import styles from './styles.module.css'
import { projectData } from "../../Data/Index";
const Projects = () => {

    // const navigate = useNavigate();

    // const goBack = () => {
    //   navigate(-1);
    // }


    return (
        <div className={`about-container ${styles.portfolioPage}`}>
            <div className="content">
                <h1>Our Projects</h1>
                <div className={styles.projectList}>
                    {
                        projectData.map((pd, index) => {
                            return <Link key={index} to={`/project/${pd.proName.toLowerCase().replaceAll(" ", "-")}`} className={styles.projectBox}>
                                <div className={styles.projectImage}>
                                    <img src={pd.image} alt={pd.proName} />
                                </div>
                                <div className={styles.shade}></div>
                                <h3 className={styles.proName}>{pd.proName}</h3>
                            </Link>
                        })
                    }
                </div>
            </div>

        </div>
    )
}


export default Projects;